import { useEffect, useState } from "react";

/** Subscribes to `window.matchMedia(query)`; defaults to `defaultMatches` during SSR. */
export function useMediaQuery(query, defaultMatches = false) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return defaultMatches;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export function useIsLgUp() {
  return useMediaQuery("(min-width: 1024px)", false);
}
